import { render } from "./UiToast.vue?vue&type=template&id=15c3408a"
import script from "./UiToast.vue?vue&type=script&lang=js"
export * from "./UiToast.vue?vue&type=script&lang=js"

import "./UiToast.vue?vue&type=style&index=0&id=15c3408a&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__